export default __webpack_public_path__ + "static/media/orangeBtn.a397fa5d.svg";